import { useState, useEffect } from 'react';
import IS_BROWSER from '../isBrowser/index.js';

function usePageVisibility() {
  var getBrowserVisibilityProp = function getBrowserVisibilityProp() {
    if (IS_BROWSER) {
      var documentObj = document;
      if (typeof documentObj.hidden !== 'undefined') {
        return 'visibilitychange';
      }
      if (typeof documentObj.msHidden !== 'undefined') {
        return 'msvisibilitychange';
      }
      if (typeof documentObj.webkitHidden !== 'undefined') {
        return 'webkitvisibilitychange';
      }
    }
    return 'visibilitychange';
  };
  var getBrowserDocumentHiddenProp = function getBrowserDocumentHiddenProp() {
    if (IS_BROWSER) {
      var documentObj = document;
      if (typeof documentObj.hidden !== 'undefined') {
        return 'hidden';
      }
      if (typeof documentObj.msHidden !== 'undefined') {
        return 'msHidden';
      }
      if (typeof documentObj.webkitHidden !== 'undefined') {
        return 'webkitHidden';
      }
    }
    return 'hidden';
  };
  var getIsDocumentHidden = function getIsDocumentHidden() {
    if (IS_BROWSER) {
      var documentObj = document;
      return !documentObj[getBrowserDocumentHiddenProp()];
    }
    return false;
  };
  var _a = useState(getIsDocumentHidden()),
    isVisible = _a[0],
    setIsVisible = _a[1];
  var onVisibilityChange = function onVisibilityChange() {
    return setIsVisible(getIsDocumentHidden());
  };
  useEffect(function () {
    if (IS_BROWSER) {
      var visibilityChange_1 = getBrowserVisibilityProp();
      document.addEventListener(visibilityChange_1, onVisibilityChange, false);
      return function () {
        document.removeEventListener(visibilityChange_1, onVisibilityChange);
      };
    }
  });
  return isVisible;
}

export { usePageVisibility as default };
//# sourceMappingURL=index.js.map
